import(/* webpackMode: "eager", webpackExports: ["IdentityResultCoordinator"] */ "/usr/src/app/apps/hotpads-web-next/src/app/_components/IdentityResultCoordinator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdentityStreamBoundary"] */ "/usr/src/app/apps/hotpads-web-next/src/app/_components/IdentityStreamBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistrar"] */ "/usr/src/app/apps/hotpads-web-next/src/app/_components/ServiceWorkerRegistrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/usr/src/app/apps/hotpads-web-next/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/hotpads-web-next/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/hotpads-web-next/styled-system/styles/reset.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/hotpads-web-next/styled-system/styles/global.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/hotpads-web-next/styled-system/styles/tokens.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/hotpads-web-next/styled-system/styles/utilities.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/local/target.css?{\"path\":\"src/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/proximanova-regular-webfont.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./fonts/proximanova-bold-webfont.woff2\",\"weight\":\"700 900\",\"style\":\"normal\"}],\"display\":\"swap\",\"variable\":\"--font-proxima-nova\",\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\"]}],\"variableName\":\"proximaNova\"}");
